/**
 * Autumn's maple leaf, in the shared 120×120 LINE asset box.
 *
 * TRACED from the theme's own icon (owner 2026-08-13: "yapraklarımız icondaki
 * yapraklar olacak"), not drawn by hand — three hand-built attempts came out as
 * spiky stars, because a maple reads by its deep sinuses and rounded lobes and
 * those are exactly what eyeballing flattens. The icon's leaf was masked by
 * saturation, boundary-traced, Douglas-Peucker simplified to 69 points and
 * normalised into the 120 box; the curve below runs quadratics through the
 * MIDPOINT of every segment, so it comes back out tangent-continuous with no
 * facets.
 *
 * It is drawn in three places — the passcode dots, the Home tab button and the
 * chat wallpaper — so the geometry lives here and all three import it, the rule
 * the Everest summit, the Aurora orb and the Sequoia leaf already follow.
 */

/** The blade, stem included, crown at the top of the box. */
export const MAPLE_BLADE = 'M60.0,8.0 Q60.0,8.0 62.4,11.8 Q64.8,15.6 66.9,15.6 Q69.1,15.6 69.4,19.4 Q69.8,23.3 71.1,25.3'
  + ' Q72.4,27.3 74.2,27.8 Q76.0,28.3 77.8,27.6 Q79.6,26.8 78.4,30.1 Q77.2,33.5 77.8,37.0'
  + ' Q78.4,40.4 77.0,43.3 Q75.5,46.2 75.8,48.8 Q76.2,51.4 77.3,52.1 Q78.4,52.8 80.3,52.3'
  + ' Q82.2,51.9 87.5,45.1 Q92.7,38.3 96.2,40.3 Q99.6,42.3 105.5,40.0 Q111.5,37.8 109.3,41.1'
  + ' Q107.2,44.5 107.5,46.0 Q107.7,47.4 108.8,48.1 Q109.9,48.8 107.8,51.2 Q105.8,53.6 105.7,55.8'
  + ' Q105.6,57.9 106.9,59.8 Q108.2,61.7 110.1,62.4 Q112.0,63.1 104.7,66.9 Q97.4,70.7 95.4,72.8'
  + ' Q93.4,75.0 94.2,77.2 Q95.1,79.3 100.1,82.5 Q105.1,85.8 99.6,88.0 Q94.1,90.3 89.9,91.2'
  + ' Q85.8,92.0 83.5,93.4 Q81.2,94.8 79.8,94.7 Q78.4,94.6 72.6,91.8 Q66.7,88.9 63.6,89.1'
  + ' Q60.5,89.3 59.6,99.3 Q58.8,109.4 58.1,109.5 Q57.4,109.6 56.5,109.2 Q55.5,108.9 56.8,103.4'
  + ' Q58.1,97.9 57.8,93.4 Q57.4,88.9 55.5,88.9 Q53.6,88.9 46.4,91.8 Q39.2,94.8 36.6,93.2'
  + ' Q34.0,91.7 29.7,90.9 Q25.4,90.1 20.3,87.9 Q15.2,85.8 20.2,82.5 Q25.2,79.3 26.0,77.2'
  + ' Q26.8,75.0 24.5,72.7 Q22.1,70.3 15.1,66.6 Q8.0,62.9 10.2,62.1 Q12.3,61.4 13.5,59.5'
  + ' Q14.7,57.6 14.6,55.6 Q14.4,53.6 12.4,51.2 Q10.4,48.8 11.4,48.1 Q12.5,47.4 12.8,46.0'
  + ' Q13.0,44.5 10.8,41.1 Q8.7,37.8 14.7,40.0 Q20.6,42.3 24.1,40.3 Q27.6,38.3 32.9,45.1'
  + ' Q38.1,51.9 40.0,52.3 Q41.9,52.8 43.0,52.1 Q44.0,51.4 44.4,48.8 Q44.7,46.2 43.3,43.3'
  + ' Q41.9,40.4 42.5,37.0 Q43.1,33.5 41.9,30.1 Q40.7,26.8 42.6,27.6 Q44.5,28.3 46.1,27.8'
  + ' Q47.8,27.3 49.1,25.3 Q50.5,23.3 50.9,19.4 Q51.2,15.6 53.4,15.6 Q55.5,15.6 57.8,11.8'
  + ' Q60.0,8.0 60.0,8.0 Z';

/*
 * The VEINS used to live here. They were rebuilt twice on 2026-08-13 — first
 * because they started inside the petiole and ran outside the blade, then
 * because aiming each one at its lobe's tip pressed it against the leaf's edge —
 * and then the owner dropped them outright ("damarları komple kaldır"). Removed
 * rather than left unused: the passcode was their only consumer.
 */

/** Autumn's fire, deepest to brightest — all from the theme's own palette. */
export const MAPLE_DEEP = '#BE553E';   // ember red
export const MAPLE_MID = '#D97A32';    // rust orange
export const MAPLE_LIGHT = '#EFA83A';  // amber
export const MAPLE_GOLD = '#DEA51D';   // late-afternoon gold
/* MAPLE_BARK went with the veins: it was the ink they were drawn in, and nothing
 * else ever used it. */
